import formRegister from './components/form-register';
import countdown from './components/countdown';

export { formRegister, countdown };
